module.exports = __webpack_public_path__ + "img/base-socket.prt.22da8746.jpg";